<template>
	<div class="binditems">
		<el-dialog :title="$t('other.a142')" :visible.sync="dialogVisible" width="30%">
			<span>{{visiableMessage}}</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">{{$t('other.a884')}}</el-button>
			</span>
		</el-dialog>
		
		<el-dialog :title="$t('other.a1900')" :visible.sync="caigouTable" center width="60%">
			<div style="height: 460px;">
				<el-table :data="isChooseList" height="90%">
					<el-table-column property="name" :label="$t('other.a1901')" width="300" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.name" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column property="variation.name" label="sku" width="200" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-input size="mini" v-model="scope.row.variation.name" ></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a1902')">
						<template scope="scope">
							<el-input size="mini"  type="number"  v-model="scope.row.cost" clearable></el-input>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a33')" width="80px">
						<template scope="scope">
							<el-button type="text" size="mini" @click="addBindToList(scope.row,scope.row.variation)" style="width: 60px;">{{$t('other.a312')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<div class="choos-store">
					<div class="select-store">
						<span>{{$t('other.a1905')}}：</span>
						<el-select v-model="chosedStore" size="small" :placeholder="$t('other.a1903')" style="margin-right: 300px;">
							<el-option v-for="store in storeList" :key="store.value" :label="store.label" :value="store">
							</el-option>
						</el-select>
					</div>
					<div >
						<el-button size="mini" @click="cleanForm">{{$t('other.a1906')}}</el-button>
						<el-button size="mini" @click="createOrder" type="primary">{{$t('other.a1907')}}</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
	
		<el-dialog :title="$t('binditems').details.title" :visible.sync="bindTable" center width="80%">
			<div class="serchCuscode-box">
				<div v-show="groupId == null" class="serchCuscode">
					<el-input
					style="width: 200px;"
					size="mini"
					  :placeholder="$t('binditems').bindDetexl.tip"
					  v-model="cusCode"
					  clearable>
					</el-input>
					<el-button size="mini" type="primary" @click="toSearchCuscode">{{$t('binditems').bindDetexl.search}}</el-button>
					
				</div>
				<el-table :data="bindItemList" width="70%" height="280px" border>
					<el-table-column property="name" :label="$t('binditems').bindDetexl.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<!-- <el-input size="mini" v-model="scope.row.image" clearable></el-input> -->
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="shopid" :label="$t('binditems').bindDetexl.shopId" width="140" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="name" :label="$t('binditems').bindDetexl.name" width="400" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="variation.name" label="sku" width="180" :show-overflow-tooltip="true">
						
					</el-table-column>
					<!-- <el-table-column :label="$t('other.a2456')" width="100">
						<template scope="scope">
							<el-input size="mini"  type="number"  v-model="scope.row.rate" clearable></el-input>
						</template>
					</el-table-column> -->
					<el-table-column  :label="$t('binditems').bindDetexl.operate" width="100" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-button type="text" size="mini" @click="deleteChoose(scope.row)" style="width: 60px;">{{$t('binditems').bindDetexl.dele}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-table v-if="curCodeList.length" :data="curCodeList" height="20%" border>
					<el-table-column property="cusCode"  :label="$t('binditems').bindDetexl.cusCode" width="100" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="itemName"  :label="$t('binditems').bindDetexl.name" width="200" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column  property="skuName" label="sku" width="100" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="storeName" :label="$t('binditems').bindDetexl.store" width="200" :show-overflow-tooltip="true"></el-table-column>
				</el-table>
				
				
				
				<div style="float: right;margin-top: 15px;">
					<el-button size="mini" @click="cleanBind">{{$t('binditems').bindDetexl.qingkong}}</el-button>
					<el-button size="mini" @click="commitBind" type="primary">{{$t('binditems').bindDetexl.submit}}</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog :title="$t('other.a1904')" :visible.sync="bindreport888" center width="90%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('other.a1908')}}</span>
				<span class="quit-wrapper-item">{{$t('other.a1909')}}</span>
			</div>
			<div class="quit-box" >
				
				<el-table :data="bindSuccess" height="460px" border>
					<el-table-column property="name" :label="$t('other.a1901')" width="100" :show-overflow-tooltip="true">
						
					</el-table-column>
					<el-table-column property="itemSku" label="skuName" width="100" :show-overflow-tooltip="true">
						
					</el-table-column>
					<el-table-column property="cusCode" label="cusCode" width="100" :show-overflow-tooltip="true">
						<template scope="scope">
							<div v-show="!scope.row.hasVariation">{{scope.row.cusCode}}</div>
							<div v-show="scope.row.hasVariation">{{scope.row.variation.cusCode}}</div>
						
						</template>
					</el-table-column>
					
				</el-table>
				<el-table :data="bindError" height="460px" border>
					<el-table-column property="name" :label="$t('other.a1901')" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="itemSku" label="skuName" width="100" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="cusCode" label="cusCode" width="200" :show-overflow-tooltip="true">
						<template scope="scope">
							<div v-show="!scope.row.hasVariation">{{scope.row.cusCode}}</div>
							<div v-show="scope.row.hasVariation">{{scope.row.variation.cusCode}}</div>
					
						</template>
					</el-table-column>
					
					
				</el-table>
		
			</div>
			
			<div class="ttp-uu">
				<el-button @click="closeWindow" type="primary">{{$t('other.a145')}}</el-button>
			</div>
			
		</el-dialog>
		
		<el-dialog :title="$t('binditems').details.title" :visible.sync="bindreport" center width="80%">
			<div class="quit-wapper">
				<span class="quit-wrapper-item">{{$t('binditems').details.success}}</span>
				<span class="quit-wrapper-item">{{$t('other.a1910')}}</span>
			</div>
			<div class="quit-box" >
				<el-table style="margin-left: 10px;" :data="bindSuccess" height="400px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="changeImgURL(scope.row)" style="width: 150px;height: 150px" />
								<img slot="reference" :src="changeImgURL(scope.row)" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="name" :label="$t('binditems').details.name" width="250" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="itemSku" :label="$t('binditems').details.SKU" width="150" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column property="cusCode" :label="$t('binditems').details.cusCode"  width="136" :show-overflow-tooltip="true">
					</el-table-column>
					
				</el-table>
				<el-table style="margin-left: 10px;" :data="bindError" height="400px" border>
					<el-table-column property="name" :label="$t('binditems').details.Img" width="60" :show-overflow-tooltip="true">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="bindMsg" :label="$t('other.a677')"  :show-overflow-tooltip="true">
					</el-table-column>
				</el-table>
			</div>
			<div class="ttp-uu">
				<el-button @click="closeWindow" type="primary">{{$t('binditems').details.ok}}</el-button>
			</div>
			
		</el-dialog>
		
		
		<div class="header-top">
			<div class="query-list">
				<div class="query-list-tcp">
					<div class="mygoods-search ">
						<el-select @change="getShopItems()" v-model="shipId.value" :placeholder="shopList[0].label" size="small">
							<el-option v-for="item in shopList"  :key="item.label" :label="item.label" :value="item">
							</el-option>
						</el-select>
					</div>
					<div class="mygoods-search create">
						<el-input clearable size="small" :placeholder="$t('binditems').search_tip" v-model="itemNameQuery"></el-input>
						 <el-button size="mini" type="primary" @click="goTosearch()">{{$t('binditems').search}}</el-button>
					</div>
				</div>
				<div class="query-list-tcp">
					<div class="create" v-show="isBindItemModel">
						<el-button type="primary " style="width:120px;margin-right:25px" @click="tobindItem" size="small" plain>{{$t('binditems').Generate_warehouse_items}}</el-button>
						<span class="cirlle">{{itemCount}}</span>
					</div>
				</div>
			</div>
		</div>
		
				<div class="mygoods-list">
					<div v-for="item in newmygoodslist" :key="item.itemId">
						<div class="list-item">
							<el-row>
								<el-col :span="24">
									<div class="item-view">
										<div style="display: flex;">
											<div class="goods-pic"><img :src="changeImgURL(item)"></div>
											<div class="goods-desc">
												<div class="goods-title">{{item.name}}</div>
												<div class="goods-title-desc">
													<span class="goods-item">{{$t('other.a249')}}{{item.itemSku}}</span>
													<span class="goods-item">{{$t('binditems').shop}}：{{item.shopName}}</span>
													<span class="goods-item">{{$t('binditems').itemID}}：{{item.itemId}}</span>
													<span class="goods-item">{{$t('binditems').price}}：{{item.price}}({{item.currency}})</span>
													<span class="goods-item">{{$t('binditems').stock}}：{{item.stock}}</span>
												</div>
												<div class="goods-title-desc">
													<span class="goods-item" v-if="item.cusCode !== 0">{{$t('binditems').cusCode}}：{{item.cusCode}}</span>
													<span class="goods-item">{{$t('binditems').sales}}：{{item.sales}}</span>
													<span class="goods-item">{{$t('binditems').satus}}：{{conversionStatus(item.status)}}</span>
													<span class="goods-item">{{$t('binditems').update}}：{{getTime(item.updateTime)}}</span>
												</div>
											</div>
										</div>
										<div v-if="groupId == null">
											<div v-show="!isBindItemModel&&item.cusCode==0 ">
												<el-button style="width:120px" type="primary" size="mini" @click="targetVariation(item,null)"  :disabled="item.hasVariation">{{addItmes}}</el-button>
											</div>
											<div  v-show="isBindItemModel&&item.cusCode==0">
												<el-button style="width:120px" type="primary" size="mini" @click="addBindToList(item,null)" v-if="!item.checked "  v-show="!item.hasVariation ">{{$t('binditems').bind}}</el-button>
												<el-button style="width:120px" type="danger" size="mini" @click="addBindToList(item,null)" v-if="item.checked"   v-show="!item.hasVariation ||  groupId !== null">{{$t('binditems').isTarget}}</el-button>
											</div>
																			
											<div  v-show="item.cusCode>0&&isBindItemModel ">
											  <div class="ppo">
												  <el-button style="width:120px;margin-bottom: 5px; " type="success" size="mini"  :disabled="item.hasVariation">{{$t('binditems').generated}}</el-button>
												 <el-button style="width:120px;margin-left: 0px" type="danger" size="mini" @click="jieban(item)"  :disabled="item.hasVariation">{{$t('binditems').jieban}}</el-button>
											  </div>
											</div>
										</div>
										<div v-if="groupId !== null">
											<div v-show="!isBindItemModel&&item.cusCode==0 ">
												<el-button style="width:120px" type="primary" size="mini" @click="targetVariation(item,null)"  :disabled="item.hasVariation">{{addItmes}}</el-button>
											</div>
											<div  v-show="isBindItemModel&&item.cusCode==0">
												<el-button style="width:120px" type="primary" size="mini" @click="addBindToList(item,null)" v-if="!item.checked "  v-show="!item.hasVariation || groupId !== null">{{$t('binditems').bind}}</el-button>
												<el-button style="width:120px" type="danger" size="mini" @click="addBindToList(item,null)" v-if="item.checked"   v-show="!item.hasVariation ||  groupId !== null">{{$t('binditems').isTarget}}</el-button>
											</div>						
											<div  v-show="item.cusCode>0&&isBindItemModel ">
											  <div class="ppo">
												  <el-button style="width:120px;margin-bottom: 5px; " type="success" size="mini"  :disabled="item.hasVariation">{{$t('binditems').generated}}</el-button>
												 <el-button style="width:120px;margin-left: 0px" type="danger" size="mini" @click="jieban(item)"  :disabled="item.hasVariation">{{$t('binditems').jieban}}</el-button>
											  </div>
											</div>
										</div>
										
									</div>
								</el-col>
							</el-row>
							<!-- 有子sku -->
							<el-row v-show="item.hasVariation">
								<el-col :span="24">
									<div class="list-variation">
										<div v-for="variation in item.variations" class="variation-list">
											<div class="goods-title-desc">
												<el-row>
													<el-col :span="6" class="goods-item"></el-col>
													<el-col :span="6" class="goods-item">&nbsp;&nbsp;&nbsp;Sku：{{variation.name}}</el-col>
													<el-col :span="3" class="goods-item">{{$t('binditems').price}}：{{variation.price}}({{item.currency}})</el-col>
													<el-col :span="3" class="goods-item">{{$t('binditems').stock}}：{{variation.stock}}</el-col>
													<el-col :span="6" v-if="variation.cusCode>0" class="goods-item">{{$t('binditems').cusCode}}：{{variation.cusCode}}</el-col>
													<el-col :span="6" class="goods-btn" v-show="!groupId">
														<!-- 选择绑定 -->
														<el-button style="width:120px"  type="primary" size="mini" @click="addBindToList(item,variation)" v-if="!variation.checked"  v-show="isBindItemModel&&variation.cusCode==0">{{$t('binditems').bind}}</el-button>
														<!-- 解除绑定 -->
														<el-button style="width:120px"  type="danger" size="mini" @click="addBindToList(item,variation)" v-if="variation.checked" v-show="isBindItemModel&&variation.cusCode==0">{{$t('binditems').isTarget}}</el-button>
														<!-- 已绑定 -->
														<el-button style="width:120px;margin-bottom: 5px;"  type="success" size="mini"  v-show="variation.cusCode>0&&isBindItemModel">{{$t('binditems').generated}}</el-button>
														<!-- 解绑定 -->
														<el-button style="width:120px"  type="danger" size="mini" @click="jieban(item,variation)"  v-show="variation.cusCode>0&&isBindItemModel">{{$t('binditems').jieban}}</el-button>
													</el-col>
												</el-row>
											</div>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
					<!-- 分页器 -->
					<div class="Pager">
					    <el-pagination
					      @size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage1"
						:page-sizes="[15, 20, 30, 50]"
						:page-size="15"
						layout="total, sizes, prev, pager, next, jumper"
						:total="goodsTotal">
					    </el-pagination>
					  </div>
				</div>
			
		
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')),
			   lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				shopList: [{
					label: this.$t('binditems').allShop,
					value: ''
				},],
				storeList: [],
				status: {
					NORMAL: this.$t('other.a1082'),
					UNLIST: this.$t('other.a1083'),
					BANNED: this.$t('other.a1911'),
					DELETED: this.$t('other.a1912')
				},
				shipId: {
					value:{
						label:''
					}
				},
				chosedStore: '',
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				bindItemList: [],
				caigouTable: false,
				bindTable: false,
				count: 0,
				dialogVisible: false,
				remindDialog: false,
				itemCount: 0,
				arr: [],
				isBindItemModel: true,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				remindCount: 0,
				selectShop: '',
				getDataPrams:{},
				offset:15,
				currentPage:0,
				type:0,
				currentPage1:0,
				goodsName:null,
				cost_prict:'',
				sku_name:'',
				storetable:false,
				input10:'',
				bindSuccess:[],
				bindError:[],
				bindreport:false,
				addItmes:this.$t('other.a1913'),
				activeTheOne:true,
				bindreport888:false,
				cusCode:'',
				isShopee:true,
				activeName:'first',
				groupId:null,
				
			}
		},
		components: {},
		
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				bindItemList01: state => state.userStoreItems.bindItemList01,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				
			}),
			remindList() {
				return this.stockRemindList;
			},
			
			newmygoodslist(){
				let arr=this.mygoodslist
				return arr
			
			}
				
		},
		watch:{
			itemNameQuery(){
				if(this.itemNameQuery == ""){
					this.getDataPrams.itemName=''
					this.getShopAllItems(this.getDataPrams)
				}
			},
			successtotal(){
				
				this.showMessage(this.$t('other.a964')+this.successtotal+this.$t('other.a1914')+this.shipId.shopId.shopName + this.$t('other.a1861'))
			}
		},
		created(){
			this.ttp()
			// this.getShopItems01()
			// this.bangding()
		},
		methods: {
			...mapActions('mygoods', [
				'getShopAllItems',
				'addGoodsInStore',
				'getBindInfo01',
				'getLazadaWarehouseitems',
				'bindBYsku'
				]),
			...mapMutations('mygoods', [
				'GET_CURCODE_LIST_NULL',
				'SET_SUCCESS_ERROR_NULL',
				'KEEP_CHOOSED_ITEM'
				
			]),
			
			...mapActions('userStoreItems', [
				'getStoreItem',
				'createCaiGouTable',
				'viewBindItems',
				'deleStoreItems',
				'jiebanItems',
				'updateItemInfo',
				'updateStoreItem',
				'updateShopeeItemStock'
				]),
				
				
				handleClick(tap) {
				
				   if(tap.label === "shopee") {
					   this.selectShop=''
					   this.isShopee=true
					   this.shopList=[{
					   	value: '',
					    	label: this.$t('other.a1915')
					       },
					   	]
						this.shipId= {
							value:{
								label:''
							}
						}
					   this.userShops.forEach(item => {
					   	let oop={
					   		label:item.shopName,
					   		value:item.shopId
					   	}
					   	this.shopList.push(oop)
					   })
					   this.getShopItems()
				   }else if(tap.label === "Lazada") {
					    this.selectShop=''
					   this.isShopee=false
					  this.shopList=[{
					  	value: '',
					   	label: this.$t('other.a1915')
					      },
					  	]
						this.shipId= {
							value:{
								label:''
							}
						}
					   let arr=this.lazadashopId.map(p => {
						  return {
							   label:p.name,
							   value:p.sellerId
						   }
					   })
					   arr.forEach(p => {
						   this.shopList.push(p)
					   })
					
				   }
				   this.getShopItems()
				  },
				
				jieban(item,variation) {
					console.log(item)
					console.log(variation)
					let cusCode=item.cusCode? item.cusCode : variation.cusCode
					this.viewBindItems({cusCode:cusCode,userId:this.userId}).then(() => {

						console.log('jfd',this.bindItemList01)
						console.log(cusCode)
						
						if (variation == null) {
							variation = {
								variationId: 0
							}
						}
						let param = JSON.parse(JSON.stringify(item));
						this.$set(param, "variation", variation);
						
						setTimeout(() => {
		
								this.jiebanItems(param)
								if(this.isShopee) {
									this.mygoodslist.forEach(p =>{
										if(!p.hasVariation) {
											if(p.cusCode === param.cusCode && p.itemId === param.itemId) {
												p.cusCode=0
											}
										}else if(p.hasVariation){
											console.log(1111)
												p.variations.forEach(k => {
													if( k.cusCode === param.variation.cusCode &&  k.variationId === param.variation.variationId) {
														k.cusCode=0
													}
												})	
										}
										
									})
								}else{
									this.lazadaitems.forEach(p =>{
										if(!p.hasVariation) {
											if(p.cusCode === param.cusCode && p.itemId === param.itemId) {
												p.cusCode=0
											}
										}else if(p.hasVariation){
											console.log(1111)
												p.variations.forEach(k => {
													if( k.cusCode === param.variation.cusCode &&  k.variationId === param.variation.variationId) {
														k.cusCode=0
													}
												})	
										}
										
									})
								}
								
							
						},500)
						
					})
					
					
				},
			
			bangding(){
				this.cusCode=this.$route.query.cusCode
				this.groupId=this.$route.query.groupId
				this.itemNameQuery=this.$route.query.itemSku
				
				
				if(this.cusCode){
					this.toSearchCuscode()
					this.groupId=null
				}else{
					
					this.goTosearch()
				}
			},
		
			deleteChoose(item) {
				
				console.log(item)
				console.log(this.mygoodslist)
				var index = this.bindItemList.findIndex(choose => {
					if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
						return true
					}
				})
				
				this.mygoodslist.forEach(p => {
					if(item.itemId==p.itemId){
						if(item.hasVariation&&p.hasVariation){
							p.variations.forEach(q=>{
								if(q.variationId==item.variation.variationId){
									q.checked=false;
								}
							})
						}else if(!item.hasVariation&&!p.hasVariation){
							p.checked =false
						}
					}
					// if(item.itemId==p.itemId&& ((item.hasVariation&&p.hasVariation&&item.variation.variationId==p.variation.variationId)||(!p.hasVariation&&!item.hasVariation))) {
					// 	p.hasvariation? p.variation.checked=false:p.checked =false
					// }
				})
				
				this.bindItemList.splice(index, 1);
				this.itemCount = this.bindItemList.length;
			},
			suggest() {
				this.remindDialog = true;
			},
		
			changeImgURL(item) {
				return item.image
				
			},
			getShopNmae(shopId) {
				return this.userShops.find(shop => shop.shopId == shopId).shopName;
			},
			getVariantNmae(row) {
				if (row.variationId == 0 || row.variationId == '') return ""
				return row.item.variations.find(variation => variation.variationId == row.variationId).name;
			},
			addBindToList(item, variation) {
				console.log(item);
				
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				let i = 0
				for (; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation){
							isInList = true;
						break;
							
						} 
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) {
								isInList = true;
								break;
							}
					}

				}
				item.checked= !item.checked
				variation==null?null:variation.checked=!variation.checked
				
				
				if (!isInList) this.bindItemList.push(param);
				else {
					this.bindItemList[i].checked= !this.bindItemList[i].checked
					this.bindItemList[i]==null?null:this.bindItemList[i].checked=!this.bindItemList[i].checked
					this.bindItemList.splice(i,1);
				}	
				this.itemCount = this.bindItemList.length
				this.KEEP_CHOOSED_ITEM(this.bindItemList)
				console.log('需要绑定的商品',this.bindItemList)
			},
			//绑定商品提交
			commitBind() {
				
				if(this.groupId == null){
					if(!this.cusCode )  {
					   alert(this.$t('other.a1916'))
					   return
					}else{
						this.bindItemList.forEach(p => {
							p.rate=Number(p.rate)
							if(p.hasVariation){
								p.variation.rate=Number(p.rate)
							}
						})
						console.log(this.bindItemList)
						let param={
							cusCode:this.curCodeList[0].cusCode,
							otherItem:this.bindItemList,
							userId:this.userId
							
							
						}
						console.log(param)
						
						api.bindItem(param).then(res => {
							if (res.code === 200) {
								console.log('jkjfdd',res.data)
								if(res.data.errorItems.length) {
									this.bindError=res.data.errorItems
								}
								if(res.data.succcessItems.length) {
									this.bindSuccess=res.data.succcessItems
								}
								
								this.bindreport=true
								this.bindTable = false;
								this.bindItemList=[]
								this.itemCount=0
								this.GET_CURCODE_LIST_NULL()
								this.input10=''
								
							}
						})
					}
				}else{
					let params={
						groupId:this.groupId,
						itemIds:this.bindItemList.map(p => {return p.itemId})
					}
					console.log(params)
					
					
					api.bindBYsku(params).then(res => {
						if (res.code === 200) {
							console.log('jkjfdd',res.data)
							
								this.bindError=res.data.errorItems
						
								this.bindSuccess=res.data.succcessItems
							
							console.log(this.bindError)
							console.log(this.bindSuccess)
							this.bindreport=true
						// 	this.bindTable = false;
						// 	this.bindItemList=[]
						// 	this.itemCount=0
						
						// 	this.input10=''
							
						}
					})
					
					
				}
				
				
				
			},
			//商店筛选框触发
			getShopItems() {
				let shoidList=this.shopList.slice(1).map(p => {return p.value})
				this.getDataPrams.shopIds=this.shipId.value.value== '' ? shoidList : [this.shipId.value.value]
				this.getDataPrams.page=0
				this.currentPage1=0
				this.getShopAllItems(this.getDataPrams)	
			},

				ttp(){
				this.cusCode=this.$route.query.cusCode
				this.groupId=this.$route.query.groupId
				this.itemNameQuery=this.$route.query.itemSku
				
				
				
				
				this.userShops.forEach(item => {
					let oop={
						label:item.shopName,
						value:item.shopId
					}
					this.shopList.push(oop)
				})

				if(this.cusCode){
					this.toSearchCuscode()
					this.groupId=null
					this.getShopItems01()
				}else{
					
					this.goTosearch()
				}

				
				
			},
			
			getShopItems01() {
				this.getDataPrams.offset=this.offset,
				this.getDataPrams.page=this.currentPage,
				this.getDataPrams.userId=this.userId,
				this.getDataPrams.itemName='',
				this.getDataPrams.shopIds=this.shopList.slice(1).map(p => {return p.value})
				this.getDataPrams.status='NORMAL',
				this.getDataPrams.categoryIds=null
				this.getShopAllItems(this.getDataPrams)
			},

			goTosearch(){
				this.getDataPrams.offset=this.offset,
				this.getDataPrams.page=this.currentPage,
				this.getDataPrams.userId=this.userId,
				this.getDataPrams.itemName='',
				this.getDataPrams.shopIds=this.shopList.slice(1).map(p => {return p.value})
				this.getDataPrams.status='NORMAL',
				this.getDataPrams.categoryIds=null,
				  this.goodsName=this.itemNameQuery
				  this.getDataPrams.itemName=this.goodsName
				 
				this.getShopAllItems(this.getDataPrams)
				  
			  },
			updateFromShopee() {
				if (this.selectShop == '') {
					this.showMessage(this.$t('other.a1917'))
				} else {
					api.updateItems(this.selectShop).then(res => {
						if (res.code === 200) {
							this.showMessage(this.$t('other.a1918'))
							this.getShopAllItems(this.selectShop)
						}
					})
				}

			},
			//创建采购单
			createOrder() {
				let variantList = [];
				let chooseList = this.isChooseList;
				console.log(this.isChooseList)
				
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a1919'));
					return;
				}
				if (this.chosedStore == '') {
					this.showMessage(this.$t('other.a1920'));
					return;
				}
				for (let i = 0; i < chooseList.length; i++) {
				
					let variation = {
						address:'',
						cost:chooseList[i].cost,
			            itemId:chooseList[i].itemId,
						itemName:chooseList[i].name,
						shopName:chooseList[i].shopName,
						shopId:chooseList[i].shopid,
						image:chooseList[i].image,
						skuName:chooseList[i].variation.name,
						storeId:this.chosedStore.value,
						storeName:this.chosedStore.storeName,
						userId:this.userId,
						userName:this.userName,
						variationId:chooseList[i].variation.variationId,
						
					}
					
					variantList.push(variation);
				}
				
				console.log(variantList)
				this.addGoodsInStore(variantList)
				this.storetable=true
		
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			//状态转换
			conversionStatus(ttp) {

				return this.status[ttp]
			},
			unique(arr, type) { // 根据唯一标识orderId来对数组进行过滤
				const res = new Map(); //定义常量 res,值为一个Map对象实例
				//返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
				if (type == 'loupan') {
					return arr.filter((arr) => !res.has(arr.bizid) && res.set(arr.bizid, 1))
				} else {
					return arr.filter((arr) => !res.has(arr.code) && res.set(arr.code, 1))
				}
			},
			tocaiguo() {
				api.getSellerStore(this.userInfo.userId).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.storeList = [];
						for (let i = 0; i < res.data.length; i++) {
							this.storeList.push({
								value: res.data[i].storeId,
								label: res.data[i].storeName + '(' + res.data[i].userName + ')',
								storeName:res.data[i].storeName
							})
						}
						this.chosedStore = '';
					}
				});
				this.caigouTable = true;
			},
			tobindItem() {
				this.bindTable = true;
				if(this.groupId==null){
					this.toSearchCuscode()
				}
				
			},
			setShopNames(){
				alert(1)
			},
			targetVariation(item, variation) {
			
				console.log('iip',item)
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "num", 0);
				this.$set(param,"skuName" ,'')
				this.$set(param,"cost" ,0)
				// this.$set(param,"shopName" ,this.shipId.value.label)
				this.$set(param, "anotherName", "");
				this.$set(param, "variation", variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation)
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if ((param.hasVariation && this.isChooseList[i].hasVariation &&
							this.isChooseList[i].variation.variationId == param.variation.variationId) ||
						(!param.hasVariation && !this.isChooseList[i].hasVariation && this.isChooseList[i].itemId == param.itemId))
						isInList = true;
				}
				if (!isInList) this.isChooseList.push(param);
				this.count = this.isChooseList.length
				console.log(this.isChooseList)
			},
			cleanForm() {
				this.isChooseList = [];
				this.sellerMessage = '';
			},
			cleanBind() {
				this.bindItemList = [];
				this.KEEP_CHOOSED_ITEM(this.bindItemList)
				this.getShopItems01()
				this.itemCount = this.bindItemList.length
			},
			
			//控制每页显示订单条数
			handleSizeChange(val) {
							 console.log(`每页 ${val} 条`);
							 this.offset=parseInt(`${val}`)
							 this.getDataPrams.offset=this.offset
							 this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
						 this.currentPage=(parseInt(`${val}`) -1) * this.offset
						//  this.currentPage1=parseInt(`${val}`)
						 this.getDataPrams.page=this.currentPage
						 console.log('11',this.getDataPrams)
						 this.getShopAllItems(this.getDataPrams)
			  },
			  //搜索商品名称查找
			  
			  open2() {
				  console.log(this.shipId.shopId.shopName)
				  this.showMessage(this.$t('other.a964')+this.successtotal+this.$t('other.a1921')+this.shipId.shopId.shopName + this.$t('other.a1861'))
			          this.$message({
			            message: this.$t('other.a1922'),
			            type: 'success'
			          });
			  },
			  oninput(e) {
			          // 通过正则过滤小数点后两位
					  console.log('e',e.target.oninput)
			        e.target.cost_prict = (e.target.cost_prict.match(/^\d*(\.?\d{0,2})/g)[0]) || null
			  
			          
			   },
			   closeWindow(){
				   this.storetable=false
				   this.caigouTable=false
				   this.count=0
				   this.bindreport=false
				   this.bindTable=false
				   this.SET_SUCCESS_ERROR_NULL()
				   this.getShopItems01()
				    if(this.$route.query.component=='products'){
					   this.$router.push({path:'/userStoreItems/products'})
					  
					}else if(this.$route.query.component=='accessories'){
					  this.$router.push({path:'/userStoreItems/accessories'})
					}
				  
			   },
			   toSearchCuscode(){
				   
				  this.GET_CURCODE_LIST_NULL()
				   const param={
					   cusCode:this.cusCode,
					  
				   }
				    console.log(this.input10)
					this.getBindInfo01(param)
					console.log(this.curCodeList)
			   }


		}
	}
</script>

<style>

	.binditems .demo-table-expand {
		font-size: 0;
	}

	.binditems .demo-table-expand label {
		width: 120px;
		color: #99a9bf;
	}

	.binditems .demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.binditems {
		flex: 1;
		/* padding: 60px 0 0 221px; */
		
	}

	.binditems .el-dialog__body {
		padding-top: 0px;
	}

	.binditems .list-item {
		justify-content: space-around;
		align-items: center;
		margin: 5px;
		box-sizing: border-box;
		padding: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}

/* 	.list-variation {
		justify-content: space-around;
		align-items: center;
	} */

	.binditems .item-view {
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		padding: 0 20px;
		border-bottom: 1px solid #eee;
		/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1); */
	}
	.binditems .goods-title-desc .el-row {
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    box-sizing: border-box;
	    padding: 0 20px;
	}
	.binditems .quit-box{
		display: flex;
	}

	.binditems .variation-list {
		padding: 5px 0;
		border-bottom: 1px #eee solid;
	}

	.binditems .el-collapse-item__content {
		padding: 0rem;
	}

	.binditems  .goods-pic {
		width: 80px;
		height: 80px;
	}

	.binditems .el-dialog__body {
		padding-bottom: 0px !important;
	}

	img {
		width: 100%;
	}

	.binditems .el-collapse-item__header {

		float: right;
	}

	.binditems .goods-desc {
		display: flex;
		margin-left: 20px;
	
	}

	.binditems .goods-item {
		display: inline-block;
		margin: 2px 10px;
		color: #00193A;
	}
	.binditems .goods-btn {
		display: inline-block;
		text-align: right;
	}
	.binditems .goods-title-desc{
		display: flex;
		flex-direction: column;
	}
	

	.binditems .goods-title {
		width: 300px;
		color: red;
		    box-sizing: border-box;
		    padding: 5px;
	}

	.binditems .mygoods-title,
	.binditems .query-list {
		display: flex;
		justify-content: space-between;
	    margin-top: 20px;
		padding: 10px;
		box-sizing: border-box;
		/* border-bottom: 1px #E0E0E0 solid; */
		
	}

	.binditems .shop-choose {
		display: inline-block;
		margin-right: 15px;
	}

	.binditems .create {
		position: relative;
		margin-left: 30px;
	}

	.binditems .cirlle {
		position: absolute;
		top: -15px;
		left: -13px;
		display: block;
		width: 30px;
		height: 30px;
		background-color: red;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
		color: #fff;
	}
	.binditems .mygoods-search {
		display: flex;
	}
	.binditems .quit-box{
		display: flex;
		justify-content: center;
		width: 90%;
	}
	.binditems .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}
	.ppo{
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}
	.binditems .choos-store{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	.binditems .quit-wapper{
		display: flex;
		justify-content: space-between;
		width: 55%;
	}
	.binditems .quit-wrapper-item{
		font-size: 18px;
	}
	.binditems .ttp-uu{
		text-align: right;
		box-sizing: border-box;
		padding: 10px;
		width: 100%;
	}
	.binditems .serchCuscode{
		display: flex;
		margin-bottom: 5px;
		
	}
	
	/** 去除input输入框样式 */
	input[type=number]::-webkit-inner-spin-button {
	  -webkit-appearance: none;
	}
	.binditems .number__input {
	  border: 1px solid #ccc;
	}
	.binditems .el-dialog--center .el-dialog__body{
		padding: 0px !important;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		align-items: center;
	}

	.binditems .el-message--success{
		z-index: 9999999!important;
	}
/* 	.mygoods .el-table__header-wrapper{
		display: flex;
		justify-content: center;
	} */
	.binditems .el-table__empty-text{
		text-align: center;
	}

	.binditems .header-top{
		position: fixed;
		width: calc(100% - 221px);
		top: 150px;
		background-color: #fff;
		z-index: 7;
		box-sizing: border-box;
		padding: 0 15px;
		border-bottom: 1px solid #eee;
	
	}
	.binditems .mygoods-list{
		margin-top: 180px;
		margin-bottom: 150px;
	
	}
	.binditems .query-list-tcp{
		display: flex;
	}
	.serchCuscode-box{
		height: 460px;
		box-sizing: border-box;
		padding: 0 15px;
	}
	
	
	.binditems .el-tabs__header {
	    position: fixed;
	    margin: 10px 0 0 30px;
	    z-index: 99;
	}
	

		
	.binditems .item-view-lazada{
		 display: flex;
	 }


</style>
